import { get } from 'lodash'
import { Box, Grid, Typography } from '@mui/material'

import { ProgressBar } from 'components'
import { t } from 'i18n'
import { TeamInsightsProps } from '../TeamInsightsComponent/TeamInsightsComponent'

export default function TeamSparckProgressBar(props: TeamInsightsProps) {
  const { insights } = props

  const sent = get(insights, 'recognitions.all', 0)
  const goal = get(insights, 'recognitions.goal', 0)

  const percentage = Math.round((sent / goal) * 100)

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box pl={3} pr={3}>
          <ProgressBar
            progress={[
              {
                percentage: percentage,
                color: 'secondary',
              },
            ]}
            showLabel
            withGradient
          />
        </Box>
      </Grid>
      <Grid container justifyContent='space-between'>
        {[
          {
            label: t('insights.sparcksProgressLabels.sent'),
            value: sent,
            align: 'left',
          },
          {
            label: t('insights.sparcksProgressLabels.goal'),
            value: goal,
            align: 'right',
          },
        ].map((legend: any) => (
          <Box pl={3} pr={3} key={legend.value}>
            <Grid item xs={12}>
              <Typography
                variant='body1'
                color='text.secondary'
                align={legend.align}
              >
                {legend.label}
              </Typography>
              <Typography
                variant='body2'
                color='text.primary'
                fontWeight={600}
                align={legend.align}
                paragraph
              >
                {legend.value}
              </Typography>
            </Grid>
          </Box>
        ))}
      </Grid>
    </Grid>
  )
}
